import { call, put } from 'redux-saga/effects';
import { refreshReceiptStatisticsSaga } from './refreshReceiptStatisticsSaga';
import { uploadReceipt } from '../api';
import {
  uploadReceiptFailure,
  uploadReceiptSuccess,
  fetchAllExcelTransactionsRequest,
  fetchLastReceiptUploadStatusRequest,
} from '../actions';
import { UploadReceiptRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* uploadReceiptSaga(action: UploadReceiptRequestAction) {
  try {
    let err: ApiError | null;
    const { organisationId, files, grouped } = action.payload;

    const uploadFiles: File[] = files ?? [];
    if (!uploadFiles.length) {
      yield put(uploadReceiptFailure());
      return;
    }

    const response = yield call(
      uploadReceipt,
      organisationId,
      uploadFiles,
      grouped
    );

    err = checkResponse(response?.responseMessage);
    if (err) {
      throw err;
    }

    // Extract batchId from server response so we can track receipts processing.
    const batchId: string | undefined = response?.data?.batchId;

    // Refresh transactions list so the table has data while the batch processes.
    const pageSize = 10;
    yield put(fetchAllExcelTransactionsRequest(organisationId, 1, pageSize));

    if (batchId) {
      yield put(uploadReceiptSuccess(batchId));
      // Optionally kick off an immediate status fetch so UI can reflect processing state.
      yield put(fetchLastReceiptUploadStatusRequest(organisationId));
    } else {
      yield put(uploadReceiptSuccess(''));
    }
    yield call(refreshReceiptStatisticsSaga);
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(uploadReceiptFailure());
  }
}
